import React, { Component } from 'react';
import classnames from 'classnames';
import Nav from '../../components/nav/Nav';
import Carousel from '../../components/carousel/Carousel';
import Slogan from '../../components/slogan/Slogan';
import styles from './Home.css';
import ProjectRows from '../../components/project-rows/ProjectRows';
import Footer from '../../components/footer/Footer';
import Loading from '../../components/loading/Loading';
import buildProjects from '../../utils/projects';
import langIsEn from '../../utils/langIsEn';
import BaseMeta from '../../components/base-meta/BaseMeta';
import ProjectsData from '../../constants/projects.json';

class Home extends Component {
  constructor(props) {
    super(props);
    this.onLangChange = this.onLangChange.bind(this);

    const projects = buildProjects(ProjectsData.records);
    this.state = {
      projects: projects,
      loadingAnimDone: false,
      langIsEn: langIsEn(),
    };
  }

  onLangChange() {
    this.setState({ langIsEn: langIsEn() });
  }

  render() {
    const { projects, loadingAnimDone } = this.state;

    if (!loadingAnimDone) {
      setTimeout(() => this.setState({ loadingAnimDone: true }), 1000);
      return (
        <BaseMeta
          path={this.props.location.pathname}
        >
          <Loading hide />
        </BaseMeta>
      );
    }

    return (
      <main>
        <BaseMeta
          path={this.props.location.pathname}
        />
        <Nav onLangChange={this.onLangChange} />
        <div className={classnames({ 'animated fadeIn': loadingAnimDone })}>
          <div className={styles.carouselContainer}>
            <Carousel />
          </div>
          <div className={styles.homeContainer}>
            <Slogan />
            <section className="container">
              <p className={styles.filterName}>Featured Projects</p>
              <ProjectRows projects={projects} />
            </section>

            <Footer />
          </div>
        </div>
      </main>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/home/Home.js